// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3o8py","name":"Header_name__3Malf","birthday":"Header_birthday__3_Jd4","skeleton":"Header_skeleton__2CBik"};